export const REQUEST_UPDATE_PREFERENCES = 'REQUEST_UPDATE_PREFERENCES',
  REQUEST_UPDATE_PREFERENCES_SUCCESS = 'REQUEST_UPDATE_PREFERENCES_SUCCESS',
  REQUEST_UPDATE_PREFERENCES_ERROR = 'REQUEST_UPDATE_PREFERENCES_ERROR',
  SET_MODE = 'SET_PREFERENCES_MODE',
  SET_PREFERENCE_UPDATE_STATUS = 'SET_PREFERENCE_UPDATE_STATUS',
  AUTO_CHECK = 'AUTO_CHECK',
  STANDARD = 'STANDARD',
  HELMET_TEXT = 'Paper-free preferences',
  SET_PREFERENCES = 'SET_PREFERENCES';
